import styles from './app.module.css';

import { Route, Routes, useLocation } from 'react-router-dom';
import { YearsPage } from '../pages/years-page/years-page';
import { YearPage } from '../pages/year-page/year-page';
import { MonthPage } from '../pages/month-page/month-page';
import { EventPage } from '../pages/event-page/event-page';
import { AlbumPage } from '../pages/album-page/album-page';
import { CheckoutPage } from '../pages/checkout-page/checkout-page';
import { CheckoutComplete } from '../checkout/checkout-complete';
import { Footer } from '../footer/footer';
import { Header } from '../header/header';
import { useAppDispatch, useAppSelector } from './hooks';
import { selectModal } from '../modal/modalSlice';
import { FavouritesPage } from '../pages/favourites-page/favourites-page';
import { useEffect } from 'react';
import { close } from '../header/nav/navSlice';
import classNames from 'classnames';
import { AccountPage } from '../pages/account-page/account-page';
import { PrivacyPage } from '../pages/privacy-page/privacy-page';
import { CopyrightPage } from '../pages/copyright-page/copyright-page';
import { CookiePolicyPage } from '../pages/cookie-policy-page/cookie-policy-page';
import { useGetNavQuery } from './api/nav';
import { useTheme } from './useTheme';
import { ContentProductPage } from '../pages/content-product-page/content-product-page';
import { KioskOrderPage } from '../pages/kiosk-order-page/kiosk-order-page';
import { GalleryUnavailablePage } from '../pages/gallery-unavailable-page/gallery-unavailable-page';
import { useGetSettingsQuery } from './api/api';

export function App() {
  const modalData = useAppSelector(selectModal);
  const { data: navExtras } = useGetNavQuery();
  const { data: settings } = useGetSettingsQuery();
  useTheme();
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(close());
  }, [location]);

  if (settings?.galleryAvailable === false) {
    return <GalleryUnavailablePage />;
  }

  return (
    <div
      className={classNames(styles.app, {
        [styles.modalOpen]: modalData.isOpen,
      })}
    >
      <Header />
      <div className={styles.main}>
        <Routes>
          <Route path="/" element={<YearsPage />} />
          <Route path="/year/:year" element={<YearPage />} />
          <Route path="/year/:year/month/:month" element={<MonthPage />} />
          <Route path="/event/:id" element={<EventPage />} />
          <Route path="/event/:id/album/:albumId" element={<AlbumPage />} />
          <Route
            path="/event/:id/album/:albumId/slide/:index"
            element={<AlbumPage layout="slider" />}
          />
          <Route path="/favourites" element={<FavouritesPage />} />
          <Route
            path="/favourites/slide/:index"
            element={<FavouritesPage layout="slider" />}
          />
          <Route
            path="/checkout/complete/:orderId"
            element={<CheckoutComplete />}
          />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
          <Route path="/copyright" element={<CopyrightPage />} />
          <Route
            path="/kiosk-order/:orderId"
            element={<KioskOrderPage />}
          />
          <Route
            path="/reset-password/:token"
            element={<YearsPage resetPassword={true} />}
          />
          {navExtras?.map((item) => (
            <Route
              key={item.link}
              path={`/${item.link}`}
              element={<ContentProductPage navItem={item} />}
            />
          ))}
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
